export const INITIAL_STATE = {
    customers: [],
};

export const customerReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'RECEIVE_BUSINESS_RESOURCES': {
            if ('customers' in action.payload) {
                const newState = { ...state };
                ['customers'].forEach(k => {
                    if (k in action.payload) {
                        newState[k] = action.payload[k];
                    }
                });
                return newState;
            } else {
                return state;
            }
        }
        case 'SET_ALL_CUSTOMERS':
            return {
                ...state,
                customers: action.payload,
            };
        case 'ADD_CUSTOMER':
            return {
                ...state,
                isSaving: true,
            };
        case 'ADD_CUSTOMER_SUCESS':
            return {
                ...state,
                isSaving: false,
            };
        case 'ADD_CUSTOMER_ERROR':
            return {
                ...state,
                isSaving: false,
            };
        case 'LOGOUT':
            return INITIAL_STATE;
        default:
            return state;
    }
};

export default customerReducer;
